import Languages from '../../translations';

const supportedLanguages = Object.getOwnPropertyNames(Languages);
const initialState = { language: localStorage.getItem('language'), };

const getters = {
    Translate: state => ({
        type: state.type,
        lang: state.lang,
    }),
};

const actions = {
    setLanguage({ commit }, languages) {
        if (typeof languages === 'string') {
            commit('SET_Language', languages);
        } else {
            const language = supportedLanguages.find(sl =>
                languages.find(l => (l.split(new RegExp(sl, 'gi')).length - 1 > 0 ? sl : null)));
            commit('SET_Language', language);
        }
    },
};

const mutations = {
    SET_Language(state, lang) {
        localStorage.setItem('language', lang);
        state.language = lang;
    },
};

export const lang = {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations,
};